import { render, staticRenderFns } from "./MainJouKupCard.vue?vue&type=template&id=6bc157b3&scoped=true&"
import script from "./MainJouKupCard.vue?vue&type=script&lang=js&"
export * from "./MainJouKupCard.vue?vue&type=script&lang=js&"
import style0 from "./MainJouKupCard.vue?vue&type=style&index=0&id=6bc157b3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc157b3",
  null
  
)

export default component.exports